<template>
  <div class="v3-popup physical-award-popup" v-show="physicalAwardPopupState">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title">{{ langData.physicalAwardTitle }}</div>
      <div class="v3-popup-content-content">
        <div class="physical-award-user-info">

          <!-- 真实姓名 -->
          <div class="physical-award-user-info-item">
            <div class="physical-award-user-info-item-label">
              {{ langData.realNameLabel }} <i class="required">*</i>
            </div>
            <div class="physical-award-user-info-item-value">
              <input
                maxlength="100"
                :class="{ error: physicalAwardUserState.hasNameError }"
                type="text"
                v-model="physicalAwardUserState.name"
              />
            </div>
          </div>

          <!-- 联系手机（区号 + 号码） -->
          <div class="physical-award-user-info-item">
            <div class="physical-award-user-info-item-label">
              {{ langData.phoneLabel }} <i class="required">*</i>
            </div>
            <div class="physical-award-user-info-item-value phone-value">
              <select v-model="physicalAwardUserState.areaCode" class="area-code-select">
                <option v-for="a in AREA_CODES" :key="a.code" :value="a.code">
                  {{ a.labels[curLang] || a.country }} {{ a.code }}
                </option>
              </select>
              <input
                :maxlength="currentPhoneRule.maxLen"
                type="tel"
                :class="{ error: physicalAwardUserState.hasPhoneError }"
                v-model="physicalAwardUserState.phone"
                @input="handlePhoneInput"
              />
            </div>
          </div>

          <!-- 收货地址（国家选择 + 文字输入） -->
          <div class="physical-award-user-info-item">
            <div class="physical-award-user-info-item-label">
              {{ langData.addressLabel }} <i class="required">*</i>
            </div>
            <div class="physical-award-user-info-item-value address-value">
              <select v-model="physicalAwardUserState.country" class="country-select">
                <option v-for="c in COUNTRIES" :key="c.key" :value="c.key">{{ c.labels[curLang] || c.key }}</option>
              </select>
              <input
                maxlength="200"
                :class="{ error: physicalAwardUserState.hasAddressError }"
                type="text"
                v-model="physicalAwardUserState.address"
              />
            </div>
          </div>

          <!-- 邮政编码 -->
          <div class="physical-award-user-info-item">
            <div class="physical-award-user-info-item-label">
              {{ langData.postalCodeLabel }} <i class="required">*</i>
            </div>
            <div class="physical-award-user-info-item-value">
              <input
                maxlength="10"
                :class="{ error: physicalAwardUserState.hasPostalCodeError }"
                type="text"
                v-model="physicalAwardUserState.postalCode"
              />
            </div>
          </div>

        </div>
      </div>
      <div class="v3-popup-content-footer">
        <div class="confirm-btn btns" @click="doubleCheckPhysicalAward">{{ langData.confirmBtn }}</div>
      </div>
    </div>
  </div>
  <div
    class="v3-popup physical-award-double-check-popup"
    v-show="physicalDoubleCheckPopupState"
  >
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title">{{ langData.physicalCheckTitle }}</div>
      <div class="v3-popup-content-content">
        <div class="tips" v-html="langData.confirmShippingTip"></div>
      </div>
      <div class="v3-popup-content-footer">
        <Transition name="toast">
          <div class="toast" v-if="showToast">{{ langData.submitSuccessTip }}</div>
        </Transition>
        <div class="confirm-btn btns" @click="handleSubmitPhysicalAward">{{ langData.confirmBtn }}</div>
        <div
          class="cancel-btn btns"
          @click="cancelDoubleCheckPhysicalAward"
        >{{ langData.cancelBtn }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, reactive, ref, computed } from "vue";
import useGetAward, { AREA_CODES, COUNTRIES } from "@/hooks/useGetAward";
import LanguageHook from "@hooks/language";

const { langData, curLang } = LanguageHook();

const showCurErrorTips = inject("showCurErrorTips", (code) => {});
const showTipMessage = inject("showTipMessage", (message) => {});
const lotteryAndTaskState = inject("lotteryAndTaskState", reactive({}));

const {
  physicalAwardUserState,
  physicalAwardPopupState,
  physicalDoubleCheckPopupState,
  doubleCheckPhysicalAward,
  cancelDoubleCheckPhysicalAward,
  submitPhysicalAward,
  resetPhysicalAwardForm,
  showToast
} = useGetAward((key) => showTipMessage(langData[key] || key), showCurErrorTips);

// 当前区号对应的验证规则
const currentPhoneRule = computed(() => {
  return AREA_CODES.find(a => a.code === physicalAwardUserState.areaCode) || { minLen: 1, maxLen: 15 };
});

const handlePhoneInput = (e) => {
  const maxLen = currentPhoneRule.value.maxLen ?? 15;
  physicalAwardUserState.phone = e.target.value.replace(/[^0-9]/g, "").slice(0, maxLen);
};

const handleClose = () => {
  physicalAwardPopupState.value = false;
  physicalDoubleCheckPopupState.value = false;
  resetPhysicalAwardForm();
};

const handleSubmitPhysicalAward = async () => {
  const res = await submitPhysicalAward();
  if (res) {
    lotteryAndTaskState.canClaimMaterialReward = false;
  }
};
</script>

<style scoped lang="less">
.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.3s ease;
}
.toast-enter-from { opacity: 0; }
.toast-enter-to { opacity: 1; }
.toast-leave-from { opacity: 1; }
.toast-leave-to { opacity: 0; }
</style>
